import { useCallback } from 'react';

import { ReturnSupportTypeOptionSelection } from './return-support-type-option-selection';
import { ReturnsInitiationOptions } from './returns-initiation-options';
import style from './style.module.less';
import { SystemAutomationContextProvider } from '../../../../../../contexts/system-automation-context';
import { Segment } from '../../../../../../services/analytics-services/segment';
import { EventSourceStrings, ClickEvents } from '../../../../../../tracking/tracking-constants';
import { useReturnsContext } from '../../context/returns-context';

/**
 * Component for the returns step in the FTU wizard.
 * Handles the returns setup process for new users.
 * @returns {JSX.Element} The rendered returns step component
 */
export const ReturnsStep = () => {
  const { shouldShowReturnsSupportOptions, selectedReturnsOption, setSelectedReturnsOption, merchantHandlesReturns } = useReturnsContext();

  const handleReturnsOptionChange = useCallback(
    (option) => {
      Segment.trackEvent(ClickEvents.FTU_OFFER_RETURNS_CLICKED, {
        source: EventSourceStrings.FTU_WIZARD_RETURNS_STEP,
        does_seller_offer_returns: option,
      });
      setSelectedReturnsOption(option);
    },
    [setSelectedReturnsOption],
  );

  return (
    <SystemAutomationContextProvider>
      <div className={style['returns-step']}>
        {shouldShowReturnsSupportOptions ? (
          <ReturnSupportTypeOptionSelection
            onReturnsOptionChange={handleReturnsOptionChange}
            selectedReturnsOption={selectedReturnsOption}
          />
        ) : null}

        {merchantHandlesReturns ? <ReturnsInitiationOptions /> : null}
      </div>
    </SystemAutomationContextProvider>
  );
};
